export const tableStatisticsPropsStyle = {
	statistic: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		width: '100%',
		padding: '12px',
		background: 'var(--default-white)',
		borderRadius: '8px',
		boxShadow: 'var(--box-shadow--1)',
		marginBottom: '24px',

		'@media (max-width: 639.98px)': {
			border: '1px solid var(--neutral-100)',
		},

		svg: {
			width: '44px',
			height: '44px',

			'@media (max-width: 639.98px)': {
				display: 'none',
			},
		},
	},

	title: {
		display: 'flex',
		flexDirection: 'column',
		whiteSpace: 'nowrap',
	},

	description: {
		color: 'var(--neutral-300)',
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '20px',
	},

	dropdown: {
		position: 'absolute',
		right: '12px',
		transform: 'translateX(-50%))',

		'@media (max-width: 1199.98px)': {
			display: 'none',
		},
	},

	action: {
		width: '100%',
		padding: '8px 16px',
		textTransform: 'capitalize',
		cursor: 'pointer',
		fontSize: '16px',
		lineHeight: '24px',
	},

	dropdownIcon: {
		'& .MuiButtonBase-root': {
			width: '16px',
			height: '16px',
			padding: 0,
		},
	},
};
